<template>
    <div class="container"  v-title="'认证机构'">
        <!-- <div class="navigation_bar">
            <div class="back_btn">
                <YD-image src="icon/icon_nav_back_white" @click.native="backPage()"></YD-image>
            </div>
        </div> -->
        <div class="container_content">
            <div class="title" v-show="titleShow">
                <h2>认证机构</h2>
                <p>CESA · 中国企业体育协会</p>
            </div>
            <div id="CertificationAuthority">
                <div class="CertificationAuthority_content">
                    <div class="info">
                        <YD-image src="rules/中企logo_认证机构"  class="logo"></YD-image>
                        <div class="name">中国企业体育协会</div>
                        <p>历史·背景·会员·伙伴·服务</p>
                    </div>
                    <div class="item_title"><span>01.</span>协会介绍</div>
                    <p class="item_introduction" style="margin-bottom:0px;">中国企业体育协会，成立于1988年，是国家民政部正式批准、接受国家体育总局业务指导的跨行业、全国性体育社团组织。是世界企业体育联合会亚洲事务副主席单位、是中华全国体育总会的团体会员、世界企业体育联合会副主席单位，是引领中国职工体育运动发展的权威机构。</p>
                    <div class="item_title"><span>02.</span>协会业务</div>
                    <div class="item_content professional_work">
                        <div>
                            <h3>赛事服务</h3>
                            <p>足球、篮球、气排球、乒乓球、羽毛球、网<br>球、棋牌、电竞、走跑、职沙会等</p>
                        </div>
                        <div>
                            <h3>培训服务</h3>
                            <p>裁判员培训、职工体育干部培训等</p>
                        </div>
                        <div>
                            <h3>健康管理</h3>
                            <p>职工体质监测、运动处方应用、线上路<br>跑、线上健步走等</p>
                        </div>
                        <div>
                            <h3>线上平台</h3>
                            <p>中国职工赛事管理系统（亿动体育APP）<br>官方推广平台（官网、官微、抖音）</p>
                        </div>
                    </div>
                    <div class="item_title"><span>03.</span>协会会员</div>
                    <p class="item_introduction">中国企业体育协会是由从事企业体育运动的组织自愿结成的非营利性社会组织，会员分布和活动地域遍布全国。</p>
                    <div class="item_content member">
                        <div>
                            <h3>行业体协<span>21</span>家</h3>
                            <p>涵盖铁路、航空、煤矿、公安、冶金、<br>林业、金融等行业体协，汇聚中国职工<br>体育中坚力量</p>
                        </div>
                        <div>
                            <h3>会员单位<span>140</span>家</h3>
                            <p>发挥职工体育纽带作用，聚合全国优质<br>体育资源，合力并举，共话发展蓝图</p>
                        </div>
                        <div>
                            <h3>覆盖全国<span>4</span>亿职工</h3>
                            <p>发挥职工体育纽带作用，聚合全国优质<br>体育资源，合力并举，共话发展蓝图</p>
                        </div>
                    </div>
                    <p class="item_introduction">多年来，中国企业体协与国际企业体育联合会、国际电子竞技联合会、西班牙职业足球联盟、中国排球协会、中国乒乓球协会、中国钓鱼协会、中国企业联合会&amp;中国企业家协会、中国健康管理协会、中华少年儿童慈善救助基金会、北京体育大学等社会组织与高校，建立起了长期、密切的战略合作关系。</p>
                    <div class="item_content partner">
                        <YD-image src="rules/协会伙伴logo"></YD-image>
                    </div>
                    <div class="item_title"><span>04.</span>会员权益</div>
                    <div class="item_content service">
                        <ul>
                            <li>
                                <h4>一、免费获得协会资料</h4>
                                1. 获得协会会刊及其他免费资料
                                <br>2. 获得协会编纂的年度《中国职工体育发展报告》
                                <br>3. 获得协会当年组织的各项活动的音像资料汇编
                            </li>
                            <li>
                                <h4>二、优先参与协会活动</h4>
                                1. 优先参加协会举办的各项职工体育赛事
                                <br>2. 优先参加协会举办的各类会展、论坛
                                <br>3. 优先参加协会组织的各类培训、交流活动
                                <br>4. 优先获得协会组织的赛事、活动的承办权
                                <br>5. 优先获得协会组织的赛事、活动的赞助权
                            </li>
                            <li>
                                <h4>三、获得会员专属资格</h4>
                                1. 可参与协会组织的年度评优及颁奖活动
                                <br>2. 可获得协会开发的赛事积分、数据信息等各类线上管理系统的高级权限
                                <br>3. 可参加协会组织的会员专属活动
                                <br>4. 可参加协会组织的国际交流活动
                            </li>
                            <li>
                                <h4>四、享受协会优惠待遇</h4>
                                1. 免费或优惠参加协会组织的赛事、活动
                                <br>2. 免费或优惠享受协会提供的竞赛组织、健康管理、运动辅导等各项服务
                                <br>3. 优惠价定制协会组织的赛事、活动的专属音像资料
                                <br>4. 优惠价购买协会提供的职工体育相关数据资料
                            </li>
                            <li>
                                <h4>五、享用协会推广渠道</h4>
                                1. 可在协会会刊、官网发表本单位推广文章
                                <br>2. 可在协会社交官媒账号（微信、微博、抖音等）发布本单位推广信息。
                                <br>3. 可获得协会会刊和网络官媒广告位
                                <br>4. 可申请协会官媒为本单位定制专题、专访
                            </li>
                            <li>
                                <h4>六、享用协会优势资源</h4>
                                1. 协助会员单位与政府主管部门、专业协会和国内外体育组织对接
                                <br>2. 为会员单位提供裁判员、教练员、培训师等专业人才和体育明星、名宿资源
                                <br>3. 为会员单位举办的赛事、活动提供官方支持（如协会领导出席）
                            </li>
                            <li>
                                <h4>七、享用会员共享平台</h4>
                                开发会员资源共享平台，为会员提供以下服务：
                                <br>1. 查询所有会员单位的基本信息
                                <br>2. 在平台上展示本单位资源或需求
                                <br>3. 与其他会员单位进行交流与合作
                            </li>
                        </ul>
                    </div>
                    <button class="Membership" @click="go()">申请入会</button>
                </div>
            </div>
        </div>
        <div class="shortcut">
            <ul>
                <li v-for="(item) in 4" :key="item" :class="'num0' + item + (item-1==activeIndex?' active':'')" @click="shortcut(item-1)"></li>
            </ul>
        </div>
    </div>
</template>
<script>
import $ from "jquery"
import {
    webviewOpenUrl
} from "@js/appInteraction"
export default {
    name: 'CertificationAuthority',
    data() {
        return {
            roll:0,
            titleShow:false,
            activeIndex:0
        }
    },
    mounted() {
        var _this = this;
        $('#CertificationAuthority').scroll(function () {
            var scroll = $('#CertificationAuthority').scrollTop();
            _this.roll = scroll;
        });
    },
    watch:{
        roll:function(scroll){
            var FS = parseInt($('html').css('font-size'));
            $('#CertificationAuthority').scrollTop(scroll);
            // if(this.titleShow && FS*3.14 > scroll){
            //     this.roll = FS*3.14 - FS*1.98 - 2;
            //     this.titleShow = false;
            // }else if(!this.titleShow && FS*3.14 - FS*1.98 <= scroll ){
            //     this.roll = scroll < FS*3.14 ? FS*3.14+2 : scroll;
            //     this.titleShow = true;
            // }
            if(FS*3.14 - FS*1.98 > scroll){
                this.titleShow = false;
            }else{
                this.titleShow = true;
            }
            var doms = $('.item_title');
            var index = 0;
            $.each(doms,function(i,item){
                if($(item).offset().top < FS*1.98 + FS*0.4){
                    index = i;
                }
            })
            this.activeIndex = index;
        }
    },
    methods:{
        backPage(){
            this.$navigation.back();
        },
        shortcut(index){
            var h = 0;
            var FS = parseInt($('html').css('font-size'));
            $.each($('.item_title').eq(index).prevAll(),function(index,item){
                h += $(item).outerHeight(true); 
            })
            this.roll = h - FS*1.98;
        },
        go(){
            webviewOpenUrl(process.env.VUE_APP_PUBLIC_URL + '/#/Rules/Membership');
        }
    }
};
</script>
<style lang="scss" scoped>
.container{
    background-color: #1B1C1E;
    background-image: url("~@images/rules/bg@2x.png");
    background-size: 100% auto;
    background-repeat: no-repeat;
    .navigation_bar{
        width: 100%;
        height: 88px;
        padding:0 40px;
        box-sizing: border-box;
        display: flex;
        align-items: center;
        justify-content: space-between;
        .back_btn{
            width: 48px;
            height: 48px;
            margin-left: -6px;
            img{
                width: 100%;
                height: 100%;
            }
        }
    }
    .container_content{
        position: relative;
        >.title{
            width: 100%;
            height: 198px;
            padding: 24px 40px 0;
            box-sizing: border-box;
            background-image: url("~@images/rules/bg@2x.png");
            background-size: 100% auto;
            background-repeat: no-repeat;
            position: absolute;
            top: 0;
            left: 0;
            box-shadow: 0 0 1px rgb(0 0 0 / 0%);
            h2{
                @include line-height(84px);
                font-size: 60px;
                color: #FFFFFF;
                font-weight: 500;
            }
            p{
                @include line-height(44px);
                font-size: 24px;
                color: #FFFFFF;
                font-weight: 400;
                margin-top: 6px;
            }
        }
    }
}
@mixin box{
    display: block;
    width: 670px;
    height: auto;
    background: #FFFFFF;
    box-shadow: 0px 4px 20px -4px rgba(136,136,136,0.25);
    border-radius: 66px;
    padding: 60px;
    box-sizing: border-box;
    margin: 0 auto;
}
@mixin title_1{
    height: 80px;
    line-height: 80px;
    font-size: 56px;
    color: #C81E26;
    letter-spacing: 1.65px;
    font-weight: 500;
    text-align: center;
}
@mixin text{
    font-size: 28px;
    color: #4D5561;
    text-align: center;
    line-height: 44px;
    font-weight: 400;
}
#CertificationAuthority{
    height: 100%;
    padding-top: 20px;
    .CertificationAuthority_content{
        padding-bottom: 50px;
        .info{
            height: 314px;
            text-align: center;
            .logo{
                width: 120px;
                height: 120px;
                margin-top: -4px;
            }
            .name{
                line-height: 60px;
                font-size: 44px;
                color: #FFFFFF;
                letter-spacing: 1.3px;
                font-weight: 500;
                margin-top: 40px;
            }
            p{
                font-size: 30px;
                color: #FFFFFF;
                line-height: 42px;
                font-weight: 200;
                margin-top: 16px;
            }
        }
        .item_title{
            height: 152px;
            width: 100%;
            padding-top: 22px;
            box-sizing: border-box;
            font-size: 32px;
            color: #FFFFFF;
            letter-spacing: 0.53px;
            line-height: 40px;
            font-weight: 600;
            display: flex;
            align-items: center;
            justify-content: center;
            span{
                font-size: 38px;
                color: #FFFFFF;
                letter-spacing: 0;
                line-height: 52px;
                font-weight: 800;
            }
        }
        .item_introduction{
            width: 100%;
            padding: 0 89px;
            box-sizing: border-box;
            font-size: 28px;
            color: #FFFFFF;
            text-align: center;
            line-height: 46px;
            font-weight: 400;
            margin-bottom: 24px;
        }
        .professional_work{
            @include box;
            >div{
                margin-bottom: 58px;
                &:last-of-type{
                    margin-bottom: 0;
                }
                h3{
                    @include title_1;
                    margin-top: 4px;
                }
                p{
                    @include text;
                    margin-top: 14px;
                }
            }
        }
        .member{
            @include box;
            margin-bottom: 40px;
            >div{
                margin-bottom: 56px;
                &:last-of-type{
                    margin-bottom: 0;
                }
                h3{
                    @include title_1;
                    span{
                        font-weight: 700;
                    }
                }
                p{
                    @include text;
                    margin-top: 16px;
                }
            }
        }
        .partner{
            width: 670px;
            height: auto;
            margin: 0 auto;
            img{
                width: 100%;
            }
        }
        .service{
            ul li{
                @include box;
                margin-bottom: 24px;
                @include text;
                text-align: left;
                &:last-of-type{
                    margin-bottom: 0;
                }
                h4{
                    font-size: 32px;
                    color: #C81E26;
                    line-height: 40px;
                    font-weight: 500;
                    margin-bottom: 16px;
                }
            }
        }
        .Membership{
            width: 670px;
            @include line-height(92px);
            background: #C81E26;
            border-radius: 36px;
            font-size: 32px;
            color: #FFFFFF;
            letter-spacing: 3px;
            text-align: center;
            font-weight: 500;
            display: block;
            margin: 60px auto 70px;

        }
    }
}
.shortcut{
    position: absolute;
    top: 540px;
    right: 20px;
    height: auto;
    width: 64px;
    background: rgba(96,79,79,0.40);
    border: 1px solid rgba(255,255,255,0.24);
    border-radius: 32px;
    padding: 0 1px;
    box-sizing: border-box;
    ul li{
        width: 60px;
        height: 60px;
        margin-bottom: 24px;
        background-repeat: no-repeat;
        background-position: center;
        background-size: 44px;
        &:last-of-type{
            margin-bottom: 0;
        }
        &.active{
            background-size: 100%;
        }
        @for $i from 1 to 5{
            &.num0#{$i}{
                @include bg-image('~@images/rules/icon/0#{$i}_白色');
                &.active{
                    @include bg-image('~@images/rules/icon/0#{$i}_红色');
                }
            }
        }
        
    }
}
</style>